import { useUserData } from './useUserData';
import { UserRole, RoleUtils } from '../types/enums';

/**
 * Hook for role-based access control
 * Supports both single role (legacy) and multiple roles (new)
 */
export const useRole = () => {
  const { userRoles: userRolesFromHook } = useUserData();

  // Get user roles - use the standardized roles from useUserData
  const userRoles = userRolesFromHook || [];

  return {
    // Current user roles
    userRoles,
    
    // Primary role (highest priority)
    primaryRole: RoleUtils.getPrimaryRole(userRoles),
    
    // Role checking functions
    hasRole: (targetRole) => RoleUtils.hasRole(userRoles, targetRole),
    hasAnyRole: (targetRoles) => RoleUtils.hasAnyRole(userRoles, targetRoles),
    hasAllRoles: (targetRoles) => RoleUtils.hasAllRoles(userRoles, targetRoles),
    
    // Common role checks
    isAdmin: () => RoleUtils.hasRole(userRoles, UserRole.ADMIN),
    isFacilityAdmin: () => RoleUtils.hasRole(userRoles, UserRole.FACILITY_ADMIN),
    isDoctor: () => RoleUtils.hasRole(userRoles, UserRole.DOCTOR),
    isNurse: () => RoleUtils.hasRole(userRoles, UserRole.NURSE),
    
    // Enhanced checks
    isAdminOrFacilityAdmin: () => RoleUtils.hasAnyRole(userRoles, [UserRole.ADMIN, UserRole.FACILITY_ADMIN]),
    isHealthcareStaff: () => RoleUtils.hasAnyRole(userRoles, [UserRole.DOCTOR, UserRole.NURSE, UserRole.ADMIN]),
    isDoctorOrNurse: () => RoleUtils.hasAnyRole(userRoles, [UserRole.DOCTOR, UserRole.NURSE]),
    
    // Display helpers
    formatRoles: () => RoleUtils.formatRolesForDisplay(userRoles),
    
    // Legacy compatibility
    role: RoleUtils.getPrimaryRole(userRoles) // For backward compatibility
  };
};

export default useRole; 